import { render } from "./CompanyMember.vue?vue&type=template&id=73a4c2b3&ts=true"
import script from "./CompanyMember.vue?vue&type=script&lang=ts"
export * from "./CompanyMember.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__